import 'angular:locale/data:en';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "en";
